<template>
  <router-link to="/services" class="about__next-page" tag="div">
    <h2 class="about__next-page--title">{{ $t("aboutTranslate.aboutNextPageLinkToNextPage") }}</h2>
  </router-link>
</template>

<script>
export default {
  name: 'about-next-page'
}
</script>

<style lang="css">
</style>
